import { Box, Grid, IconButton, Typography } from "@mui/material";
import { getDemandData, getFormData } from "api/services/automation/income-tax-tan";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { styled } from "@mui/system";
import Loader from "components/Loader";
import AccessDenied from "../../Access/accessDenide";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TraceOutstandingDemandTables from "./TraceOutstandingDeamndTable";

interface StyledSpanProps {
  bgColor?: string; // Define bgColor prop here
}

const StyledSpan = styled("span")<StyledSpanProps>(({ theme, bgColor }) => ({
  backgroundColor: bgColor || "#ffffff",
  padding: "5px",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "5px",
}));

const TraceDemandFullView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data, isLoading }: ResType = useQuery(["get demand data tan", params.id], getDemandData);
  console.log("data",data)
 
  if (isLoading) return <Loader />;
  return (
    <>
      {!data?.data && <AccessDenied />}

      {data?.data && (
        <Box m={1}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon fontSize="small" />
            <Typography variant="subtitle2" ml={1}>
              Demand List
            </Typography>
          </IconButton>
          <Box>

                <TraceOutstandingDemandTables
      tokenSummary={data?.data?.tokenSummary}
      demandSummary={data?.data?.demandSummary}
      panErrorSummary={data?.data?.panErrorSummary}
      correctionSummary={data?.data?.correctionSummary}
      information={data?.data}
    />

          </Box>
        </Box>
      )}
    </>
  );
};

export default TraceDemandFullView;
